import { type ConnectionType, ConnectionTypes } from '../services/partnerNetwork.types';

type ConnectionTypeLabelProps = {
    connectionType: ConnectionType;
    showIcon?: boolean;
    showName?: boolean;
    count?: number;
    classNames?: string;
};

const formatConnectionName = (type: string | undefined): string => {
    if (!type) {
        return '';
    }

    if (type === ConnectionTypes.RENTAL) {
        return 'RIO4Rental';
    }

    return type
        .split(/\W+/)
        .map(str => str.charAt(0).toUpperCase() + str.slice(1))
        .join(' ');
};

const ConnectionTypeLabel = (props: ConnectionTypeLabelProps) => {
    const { connectionType, showIcon = false, showName = true, count, classNames = '' } = props;

    const icons = {
        'order-exchange': 'uikit-icon icon-tms',
        rental: 'uikit-icon icon-delivery-completed',
    };

    const name = formatConnectionName(connectionType);

    return (
        <span className={`${classNames} text-color-darker`}>
            {count && <span className='padding-right-5'>{count}</span>}
            {showIcon && <span className={icons[connectionType]} />}
            {showIcon && showName && <span className='padding-right-5' />}
            {showName && name}
        </span>
    );
};

export default ConnectionTypeLabel;
